
const ServerAddress = "https://avtcbe.etechcube.com/";
const bucket_address = "https://prod-erp-avtc.s3.ap-south-1.amazonaws.com/"

export { ServerAddress, bucket_address };


